/**
 * @file: useProductDetail.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useCachedQuery } from '@euler/functions/useCachedQuery';
import { IdType } from '@euler/model/common';
import { useServiceFactory } from '@euler/services/factory';

export const useQueryProductDetail = (productId: IdType) => {
  const { productService } = useServiceFactory();
  return useCachedQuery(`products/${productId}.detail.json`, 300, async () => {
    return await productService.getProductDetail(productId);
  });
};
